import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle cx="25" cy="25" r="24" fill="white" fillOpacity="0.5" />
        <circle cx="25" cy="25" r="24.5" stroke="white" />
      </g>
      <path
        d="M35.5401 19.42C35.4213 18.9454 35.1794 18.5106 34.8387 18.1594C34.4981 17.8082 34.0708 17.5532 33.6001 17.42C31.8801 17 25.0001 17 25.0001 17C25.0001 17 18.1201 17 16.4001 17.46C15.9293 17.5932 15.5021 17.8482 15.1614 18.1994C14.8208 18.5506 14.5789 18.9854 14.4601 19.46C14.1453 21.2056 13.9913 22.9763 14.0001 24.75C13.9889 26.537 14.1429 28.3213 14.4601 30.08C14.591 30.5398 14.8384 30.9581 15.1782 31.2945C15.5181 31.6308 15.9389 31.8738 16.4001 32C18.1201 32.46 25.0001 32.46 25.0001 32.46C25.0001 32.46 31.8801 32.46 33.6001 32C34.0708 31.8668 34.4981 31.6118 34.8387 31.2606C35.1794 30.9094 35.4213 30.4746 35.5401 30C35.8524 28.2676 36.0064 26.5103 36.0001 24.75C36.0113 22.963 35.8573 21.1787 35.5401 19.42V19.42Z"
        stroke="#111111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.75 28.02L28.5 24.75L22.75 21.48V28.02Z"
        stroke="#111111"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <filter
          id="filter0_b"
          x="-10"
          y="-10"
          width="70"
          height="70"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImage" stdDeviation="5" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default Icon;
